import selectors from '../../../globals/selectors';

export default class SearchView {
	constructor(selector) {
		this.element = document.querySelector(selector);
		this.input = this.element.querySelector(selectors.search.input);
		this.resultsContainer = this.element.querySelector(
			selectors.search.resultsContainer
		);
	}

	init({
		onInputHandle,
		handleInputFocus,
		handleBodyClick,
		handleBodyKeyUp,
		handleInputClick,
	}) {
		this.input.addEventListener('input', onInputHandle);
		this.input.addEventListener('focus', handleInputFocus);
		this.input.addEventListener('click', handleInputClick);
		document.body.addEventListener('click', handleBodyClick);
		document.body.addEventListener('keyup', handleBodyKeyUp);
	}
}
